module.exports = "/images/bannerOne.jpg";